// extracted by mini-css-extract-plugin
export default {"previewBox":"x1dT7nCqyj7C6OFp2S3D","chip":"J279d6i22VO9K_wSv9CR","clearButton":"nYPUOMiwic8a5XL7dyDv"};